import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IMAGEAPI } from "../../../BackendConnections";
import { connect } from "react-redux";
import { BiLockAlt, BiLockOpenAlt } from "react-icons/bi";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";

export const UseSidebar = (props) => {

  const [paid, setPaid] = useState(props.user && props.user.is_paid);
  const [isProfileComplete, setIsProfileComplete] = useState(true);
  const [open, setOpen] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState({
    analytics: false,
    network: false,
    performance: false,
  });

  const userImg = "/assets/images/preview-img.png";

  const pathname = window.location.pathname;

  const getAttribute = (name) => {
    if (pathname === name) {
      return "active";
    } else {
      return "";
    }
  };

 const handleOpen = (tooltip) => {
    setTooltipOpen((prevState) => ({
      ...prevState,
      [tooltip]: !isProfileComplete,
    }));
  };

  const handleClose = (tooltip) => {
    setTooltipOpen((prevState) => ({
      ...prevState,
      [tooltip]: false,
    }));
  };

  useEffect(() => {
    const checkProfileCompletion = async () => {
      await new Promise(resolve => setTimeout(resolve, 1000));
      if (props.profile.profile_fill === 100) {
        setIsProfileComplete(true);
      } else {
        setIsProfileComplete(false);
      }
    };

    checkProfileCompletion();
  }, [props.profile]);

  return (
    <div
      className={
        props.menuActive === true ? "left-section active" : "left-section"
      }
    >
      <div className="user-thumb">
        <div className="img-wrap">
          <div className="hexagon-wrap">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 100 90"
            >
              <defs>
                <pattern
                  id="img0"
                  patternUnits="userSpaceOnUse"
                  width="100"
                  height="100"
                >
                  <image
                    className="hexagon-img"
                    xlinkHref={
                      props.profile.profile_pic && props.profile.profile_pic
                        ? IMAGEAPI + props.profile.profile_pic
                        : userImg
                    }
                    x="-25"
                    width="150"
                    height="100"
                  ></image>
                </pattern>
              </defs>
              <polygon
                fill="url(#img0)"
                points="25.457,92.51 0.914,50 25.457,7.49 74.543,7.49 99.086,50 74.543,92.51 "
              ></polygon>
            </svg>
          </div>
        </div>
        <div className="username">
          {props.profile.first_name} <br></br>
          {props.profile.last_name}
        </div>
      </div>

      <div className="sidebar-nav">
        <ul>
          <li>
            <Link to="/user/dashboard" className={getAttribute("/dashboard")}>
              <span className="icon">
                {/* <img src="/assets/images/icons/home.svg" alt="" /> */}
                <img src="\assets\images\icons\Asset 4.png" />
              </span>
              <span className="text">
                MY <strong>Dashboard</strong>
              </span>
            </Link>
          </li>
          {/* <li>
            <Link
              to="/user/notifications"
              className={getAttribute("/user/notifications")}
            >
              <span className="icon">
                <img src="/assets/images/icons/notification-bell.svg" alt="" />
              </span>
              <span className="text">
                <strong>NOTIFICATIONS</strong>
              </span>
            </Link>
          </li> */}

          <li className={getAttribute("/user/profile")}>
            <Link to="/user/profile" className="item-border blue">
              <span className="icon">
                <img src="/assets/images/icons/profile.svg" alt="" />
                {/* <img
                  className="active-icon"
                  src="/assets/images/icons/my_profile_without-hexagon_active.svg"
                  alt=""
                /> */}
              </span>
              <span className="text">
                {" "}
                MY <strong>Profile</strong>
              </span>
            </Link>
            <ul className="sub-menu">
              <li>
                <Link
                  to={`/user/my-profile`}
                  className={` ${isProfileComplete ? " " : "disabled"}`}
                >
                  Download Profile
                </Link>
              </li>
            </ul>
          </li>
          <Tooltip
  TransitionComponent={(props) => (
    <Zoom
      {...props}
      style={{
        fontSize: "12px",
        backgroundColor: "black", color: "white"
        
      
      }}
    />
  )}
  title={`Please complete your profile to  100% to get access`}
  open={tooltipOpen.analytics}
            onClose={() => handleClose('analytics')}
            onOpen={() => handleOpen('analytics')}
>
            <li
              className={
                getAttribute("/user/analytics") +
                getAttribute("/user/profile-analytics")
              }
            >
              <Link
                to="/user/profile-analytics"
                className={`item-border red  ${
                  isProfileComplete ? "" : "disabled"
                }`}
              >
                <span className="icon">
                  <img src="/assets/images/icons/analytics.svg" alt="" />
                  {/* <img
                  className="active-icon"
                  src="/assets/images/icons/my_Analytics-without-hexagon-active.svg"
                  alt=""
                /> */}
                </span>
                <span className="text">
                  {" "}
                  <strong>goneet</strong>&nbsp;
                  <label
                    style={{
                      backgroundColor: "#283270",
                      color: "white",
                      padding: "4px",
                      borderRadius: "5px",
                    }}
                  >
                    PRO
                  </label>
                  &nbsp;
                  {paid ? <BiLockOpenAlt /> : <BiLockAlt />}
                  {paid ? (
                    ""
                  ) : (
                    <span
                      style={{
                        display: "inline",
                        marginInline: "5px",
                        verticalAlign: "middle",
                      }}
                    >
                      {/* <BiLockOpenAlt /> */}
                    </span>
                  )}
                </span>
              </Link>
              {/* <ul className="sub-menu">
              <li>
                <Link
                  className={getAttribute("/user/profile-analytics")}
                  to="/user/profile-analytics"
                >
                  Profile
                </Link>
              </li>
            </ul> */}
            </li>
          </Tooltip>

          <Tooltip
  TransitionComponent={(props) => (
    <Zoom
      {...props}
      style={{
        fontSize: "12px",
        backgroundColor: "black", color: "white"
        
      
      }}
    />
  )}
  title={`Please complete your profile to  100% to get access`}
  open={tooltipOpen.network}
            onClose={() => handleClose('network')}
        onOpen={() => handleOpen('network')}
>
            <li
              className={
                getAttribute("/user/network") +
                getAttribute("/user/my-connections")
              }
              // title="Please Complete Profile 100% to get access"
            >
              <Link
                to="/user/network"
                className={`item-border orange  ${
                  isProfileComplete ? "" : "disabled"
                } `}
              >
                <span className="icon">
                  <img src="/assets/images/icons/network.svg" alt="" />
                </span>
                <span className="text">
                  {" "}
                  MY<strong> Network</strong>
                </span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    className={
                      getAttribute("/user/my-connections") +
                      (isProfileComplete ? " " : "disabled")
                    }
                    to="/user/my-connections"
                  >
                    Connections
                  </Link>
                </li>
              </ul>
            </li>
          </Tooltip>

          <Tooltip
  TransitionComponent={(props) => (
    <Zoom
      {...props}
      style={{
        fontSize: "12px",
        backgroundColor: "black", color: "white"
        
      
      }}
    />
  )}
  title={`Please complete your profile to  100% to get access`}
  open={tooltipOpen.performance}
            onClose={() => handleClose('performance')}
            onOpen={() => handleOpen('performance')}
>
            <li className={getAttribute("/user/performance")}>
              <Link
                to="/user/performance"
                className={`item-border green  ${
                  isProfileComplete ? "" : "disabled"
                }`}
              >
                <span className="icon">
                  <img src="/assets/images/icons/performance.svg" alt="" />
                  {/* <img
                  className="active-icon"
                  src="/assets/images/icons/my_performancewithout--hexagon-active.svg"
                  alt=""
                /> */}
                </span>
                <span className="text">
                  {" "}
                  MY<strong> Performance</strong>
                </span>
              </Link>
              <ul className="sub-menu">
                {/* <li>
                <Link to="#" className="active">
                  Job status
                </Link>
              </li> */}
              </ul>
            </li>
          </Tooltip>
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;

  return {
    user: user,
    profile: profile,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UseSidebar);
